<template>
  <div class="app-wrapper">
    <!-- 顶部导航栏 -->
    <Navbar />
    
    <!-- 主内容区域 -->
    <div class="app-main">
      <router-view />
    </div>
    
    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/qingyu'
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'

const router = useRouter()
const userStore = useUserStore()

onMounted(async () => {
  // 初始化store
  userStore.initStore()
  
  // 检查token是否有效
  if (userStore.checkTokenValidity()) {
    // 如果没有用户信息，跳转到登录页
    if (!userStore.userInfo) {
      await userStore.clearUserInfo()
      router.push('/login')
    }
  }
})
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
}

.app-main {
  flex: 1;
  padding: 20px;
  margin-top: 60px; /* 为固定顶部导航预留空间 */
}

@media screen and (max-width: 768px) {
  .app-main {
    padding: 15px;
  }
}
</style> 